// «Cancelar venta» del detalle de Ventas del Admin VL, contra `/backoffice/sales/{id}/cancel`.
// Solo aparece con `retail.sale.cancel` y en ventas completadas; nace deshabilitado si no cumple.
import { useTranslation } from 'react-i18next';
import { usePermissions } from '@/kit';
import type { BackofficeSale } from '@/api/services/retail-wizard/contract';
import type { SaleSlots } from '@/shared/patterns/SaleReceipt';
import { CancelSaleFlow, SALE_CANCEL_PERMISSION } from '@/shared/patterns/CancelSale';
import { useCancelVenta } from '../api/useVentas';
import { cancelAvailability, type SaleDetailStatus } from '../lib/cancelAvailability';

interface CancelSaleActionProps {
    sale: BackofficeSale;
    className?: string;
    /** De aquí sale el nombre de los regalos que solo traen su SKU. */
    slots?: SaleSlots;
    /** Lectura del detalle: mientras no llega no se sabe si la venta se puede cancelar. */
    detailStatus?: SaleDetailStatus;
}

export function CancelSaleAction(props: CancelSaleActionProps) {
    const { hasPermission } = usePermissions();
    if (!hasPermission(SALE_CANCEL_PERMISSION) || props.sale.status !== 'COMPLETED') return null;
    return <BackofficeCancelSale {...props} />;
}

/** Monta la mutación aparte para no pedir QueryClient a quien no puede cancelar. */
function BackofficeCancelSale({
    sale,
    className,
    slots,
    detailStatus = 'success',
}: CancelSaleActionProps) {
    const { t } = useTranslation('ventas');
    const mutation = useCancelVenta();
    const availability = cancelAvailability(sale, detailStatus, t);
    return (
        <CancelSaleFlow
            sale={sale}
            mutation={mutation}
            className={className}
            slots={slots}
            disabled={!availability.enabled}
            {...(availability.note ? { note: availability.note } : {})}
            {...(availability.lateCancelExceptionId
                ? { outOfWindowExceptionId: availability.lateCancelExceptionId }
                : {})}
        />
    );
}
